<template>
  <b-modal
    v-model="state"
    hide-footer
    hide-header
    centered
    no-close-on-backdrop
    @click.prevent.stop
  >
    <div class="h1 d-inline-flex align-items-center text-info w-100">
      <font-awesome-icon :icon="['fas', 'star']" class="mr-3" />
      <div class="h3 font-weight-bold">
        {{ $t('fCustomer_editRanking_title') }}
      </div>
    </div>
    <div class="body">
      <div
        v-if="editorialRanking"
        v-shtml="formatChange(editorialRanking)"
        class="mb-2"
      />
      <b-form-group
        id="input-reason"
        :label="$t('fCustomer_editRanking_f_reason')"
        label-for="input-reason"
        :description="$t('fCustomer_editRanking_f_reason_desc')"
      >
        <b-form-textarea
          id="input-reason"
          v-model="form.reason"
          :placeholder="$t('fCustomer_editRanking_f_reason_placeholder')"
          rows="3"
          max-rows="6"
          required
          :disabled="!!busy"
          :state="form.reason.length > 0 ? true : null"
          trim
        />
        <b-form-invalid-feedback>
          {{ $t('fCustomer_editRanking_v_reason') }}
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group class="text-right">
        <b-button
          variant="outline-secondary"
          size="sm"
          :disabled="!!busy"
          @click="onCancel"
        >
          {{ $t('fCustomer_editRanking_a_cancel') }}
        </b-button>
        <b-button
          variant="primary"
          size="sm"
          :disabled="!!busy || !reasonState"
          @click="onSubmit"
        >
          {{ $t('fCustomer_editRanking_a_submit') }}
        </b-button>
      </b-form-group>
    </div>
  </b-modal>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'EditorialRankingModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    userId: {
      type: [String, Number],
      required: true
    },
    // [ID-338] The new editorial_ranking value to save
    editorialRanking: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      state: this.value,
      busy: false,
      form: { reason: '' }
    }
  },
  computed: {
    // [ID-338] reason is mandatory — dialog cannot be submitted without it
    reasonState () {
      return this.form.reason.trim().length > 0
    }
  },
  watch: {
    value (n) {
      this.state = n
      if (!n) {
        this.form.reason = ''
        this.busy = false
      }
    }
  },
  methods: {
    ...mapActions({
      storeEditorialRanking: 'forms/customerEdit/storeEditorialRanking'
    }),
    async onSubmit () {
      if (!this.reasonState) { return }
      this.busy = true
      await this.storeEditorialRanking({
        userId: this.userId,
        payload: { editorial_ranking: this.editorialRanking.newValue, reason: this.form.reason }
      })
      this.busy = false
      this.$emit('submitted')
      this.$emit('input', false)
    },
    onCancel () {
      // Parent resets selectedValue via currentValue watcher when info reloads
      this.$emit('rejected', this.editorialRanking.oldValue)
      this.$emit('input', false)
    },
    // context shape: { from: 'OLD_RANKING', to: 'NEW_RANKING' }
    formatChange (item) {
      const from = item?.oldValue || '—'
      const to = item?.newValue || '—'
      const fromText = item?.oldValue ? `'${from}' ` : ''
      return `
        <span class="text-muted">Ranking ${fromText}changed to '${to}'</span>`
    }
  }
}
</script>

<style scoped>

</style>
